module.exports = __webpack_public_path__ + "img/setting.cf4940c0.svg";